import { Roles, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const AnalyticsHubPage = lazyPage(() => import("../analytics/AnalyticsHubPage"), "AnalyticsHubPage");
const AnalyticsKpiDetailPage = lazyPage(() => import("../analytics/AnalyticsKpiDetailPage"), "AnalyticsKpiDetailPage");

/**
 * Policy `AnalyticsReaders` (D-O77): OperationsManager, Planner, ShopSupervisor, OperationsViewer and Admin.
 * WallDisplay and Purchasing are excluded.
 */
export const AnalyticsReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Planner,
  Roles.ShopSupervisor,
  Roles.OperationsViewer,
  Roles.Admin
];

export { AnalyticsHubPage, AnalyticsKpiDetailPage };

/** Analytics area (Gate C, D-O77): KPI library, Analytics hub, Explain-this, anomalies. Owned by agent bi-hub; the integrator wires this list into App.tsx and adds the hub tabs. */
export const analyticsRoutes: AreaRoute[] = [
  {
    path: "/analytics",
    allow: AnalyticsReaders,
    element: <AnalyticsHubPage />
  },
  {
    path: "/analytics/kpi/:id",
    allow: AnalyticsReaders,
    element: <AnalyticsKpiDetailPage />
  }
];

